import { SUPER_ADMIN_EMAILS } from 'src/app/models/super-admin';

export const environment = {
    production: false,
    mockData: false,
    issuer: 'https://helixopsaiprv.oktapreview.com/oauth2/auswiob1p3HU2waOF1d7',
    clientId: '0oaxxezlfmmoKeeJl1d7',
    apiUrl: 'https://acmapidev.helixops.ai/aca/api/v1/',
    origin: 'https://acmapidev.helixops.ai',
    cmxClientUrl: 'https://docsdev.helixops.ai/docs/compatibility/#/',
    superAdminsEmails: SUPER_ADMIN_EMAILS,
    tinyMceApiKey: 'o56vwsx2pa9z816lgpgvk1ow7qm55yml4r168ec3ck6n5f5v'
};
